module.exports = __webpack_public_path__ + "static/media/BodyRelaxationTechniques.184ec3dc.mp3";